import React from "react";
import { NavLink } from "react-router-dom";
import logo from "../Images/DeepCyber_Logo_Footer.png"
import {  FaEnvelope,  FaPhoneAlt,  FaInfoCircle, FaAddressBook,  FaLaptop } from "react-icons/fa";

function Footer() {
  return (
    <footer className="py-4 border-top  bg-navyblue text-light">
      <div className="container">
        <div className="row text-center text-md-start">
          {/* Logo & Home */}
          <div className="col-md-4 d-flex flex-column align-items-md-start align-items-center">
            <NavLink to="/" className="navbar-brand">
              <img src={logo} alt="Logo" className="img-fluid mb-2" style={{ height: "60px" }} />
            </NavLink>
          </div>

          {/* Navigation Links */}
          <div className="col-md-4">
            <ul className="list-unstyled">
              <li className="mt-2"><FaInfoCircle className="me-2 " /><NavLink to="/about" className="text-light text-decoration-none"> About</NavLink></li>
              <li  className="mt-2"><FaLaptop className="me-2 " /><NavLink to="/services" className="text-light text-decoration-none">Services</NavLink></li>
              <li  className="mt-2"><FaAddressBook className="me-2" /><NavLink to="/contact" className="text-light text-decoration-none">Contact</NavLink></li>
            </ul>
          </div>

          {/* Contact Information */}
          <div className="col-md-4">
            <h5 className="fw-bold mb-3">Contact Info</h5>
            <a href="tel:+16474708468" className="text-decoration-none text-white">
              <p className="d-flex align-items-center justify-content-md-start justify-content-center mt-2">
                <FaPhoneAlt className="me-2" /> +1 (647-470-8468)
              </p>
            </a>
            <a href="mailto:info@deepcyberconsulting.com" className="text-decoration-none text-white">
              <p className="d-flex align-items-center justify-content-md-start justify-content-center mt-2">
                <FaEnvelope className="me-2" /> info@deepcyberconsulting.com
              </p>
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center mt-3">
          <p className="mb-0">© {new Date().getFullYear()} DeepCyber Consulting. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
